import fetchWebApi from 'api/fetchWebApi';

export interface PostTemporaryPasswordPayload {
  email: string;
}

const postTemporaryPasswordApiCall = async (
  payload: PostTemporaryPasswordPayload,
): Promise<void> => {
  fetchWebApi(`/client/temporary-password`, undefined, {
    method: 'post',
    body: JSON.stringify({ username: payload.email }),
  });
};

export default postTemporaryPasswordApiCall;
